export enum ReceiptType {
    PAST_MONTH_RECEIPT = 'PAST_MONTH_RECEIPT',
    CURRENT_MONTH_RECEIPT = 'CURRENT_MONTH_RECEIPT',
    FUTURE_MONTH_RECEIPT = 'FUTURE_MONTH_RECEIPT',
}
